const ignored = [
  'IN_PAGE_CHANNEL_NODE_ID in-page-channel-node-id not found',
  'Channel secret not available yet',
]

const maxMessageLen = 512
const maxStackLen = 1024
const repeatWindowMs = 30_000
const sentAtByKey = new Map()
const sessionId = globalThis.crypto?.randomUUID?.()
  || `page-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`

function textOf(value) {
  if (!value) return ''
  if (value instanceof Error) return value.message || String(value)
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value)
  } catch {
    return String(value)
  }
}

function stackOf(value) {
  if (value instanceof Error) return value.stack || ''
  return ''
}

function clipped(value, maxLen) {
  const text = String(value || '').trim()
  if (text.length <= maxLen) return text
  return `${text.slice(0, maxLen)}...[truncated]`
}

function structuredEvent(parts) {
  const event = typeof parts[0] === 'string' ? parts[0].trim() : ''
  const context = parts[1]
  if (!/^[a-z][a-z0-9_.-]{1,63}$/.test(event)) return { event: '', context: null }
  if (!context || Array.isArray(context) || typeof context !== 'object' || context instanceof Error) {
    return { event: '', context: null }
  }
  return { event, context }
}

export function isIgnoredClientNoise(...parts) {
  const message = parts.map(textOf).join(' ')
  return ignored.some(pattern => message.includes(pattern))
}

export function reportClientError(level, ...parts) {
  if (isIgnoredClientNoise(...parts)) return

  const firstError = parts.find(part => part instanceof Error)
  const message = clipped(parts.map(textOf).filter(Boolean).join(' '), maxMessageLen)
  const path = `${location.pathname}${location.hash}`
  const structured = structuredEvent(parts)
  const key = `${level}:${path}:${message}`
  const now = Date.now()
  const lastSentAt = sentAtByKey.get(key) || 0
  if (now - lastSentAt < repeatWindowMs) return
  sentAtByKey.set(key, now)

  const payload = JSON.stringify({
    level,
    event: structured.event,
    context: structured.context,
    message,
    stack: clipped(stackOf(firstError), maxStackLen),
    path,
    session: sessionId,
    clientTime: new Date(now).toISOString(),
    user: localStorage.getItem('aime.auth.token') ? 'authenticated' : '',
  })

  if (navigator.sendBeacon) {
    const blob = new Blob([payload], { type: 'application/json' })
    navigator.sendBeacon('/api/client-error', blob)
    return
  }

  fetch('/api/client-error', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
  }).catch(() => {})
}

export function installClientErrorReporter() {
  const originalError = console.error.bind(console)
  const originalWarn = console.warn.bind(console)

  console.error = (...args) => {
    if (isIgnoredClientNoise(...args)) return
    originalError(...args)
    reportClientError('error', ...args)
  }

  console.warn = (...args) => {
    if (isIgnoredClientNoise(...args)) return
    originalWarn(...args)
    reportClientError('warn', ...args)
  }

  window.addEventListener('error', event => {
    if (isIgnoredClientNoise(event.message, event.error)) return
    reportClientError('error', event.message, event.error)
  })

  window.addEventListener('unhandledrejection', event => {
    if (isIgnoredClientNoise(event.reason)) return
    reportClientError('error', event.reason)
  })
}
